import React, { Component } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import Constants from "./App/Variables/Constants";
import init from "./helpers/WindowToken";
import {
  Button,
  Snackbar,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import EditIcon from "@material-ui/icons/Edit";
import { Link, Redirect } from "react-router-dom";
// import editorConfiguration from "./variables/EditorConfiguration";
// import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
export default class AboutUs extends Component {
  state = {
    description: "",
    notification: false,
    loading: false,
    message: "",
    redirect: false,
    aboutUs: [],
    aboutId: 0,
    descError: false,
    theme: "light",
  };
  componentDidMount() {
    this.getAbout();
  }

  addAbout = () => {
    if (this.state.description === "") {
      this.setState({
        descError: true,
      });
      setTimeout(() => {
        this.setState({
          descError: false,
        });
      }, 3000);
    } else {
      let load = {
        description: this.state.description,
      };
      this.setState({ loading: true });
      if (init() === "success") {
        axios.post(Constants.postUrls.about, load).then((resp) => {
          // console.log(resp);
          if (resp.data.status === "success") {
            this.setState({
              loading: false,
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({
                notification: false,
                redirect: true,
              });
            }, 1500);
          }
        });
      }
    }
  };
  getAbout = () => {
    axios.get(Constants.getUrls.getAboutUs).then((res) => {
      // console.log(res);
      this.setState({
        description:
          res.data.docs.length > 0 ? res.data.docs[0].description : "",
        aboutId: res.data.docs.length > 0 ? res.data.docs[0]._id : "",
      });
    });
  };

  updateAbout = (id) => {
    if (this.state.description === "") {
      this.setState({
        descError: true,
      });
      setTimeout(() => {
        this.setState({
          descError: false,
        });
      }, 3000);
    } else {
      let load = {
        description: this.state.description,
      };
      this.setState({ loading: true });
      if (init() === "success") {
        axios
          .put(Constants.postUrls.about + "/" + this.state.aboutId, load)
          .then((resp) => {
            // console.log(resp);
            if (resp.data.status === "success") {
              this.setState({
                loading: false,
                notification: true,
                message: resp.data.message,
              });
              setTimeout(() => {
                this.setState({
                  notification: false,
                  redirect: true,
                });
              }, 1500);
            }
          });
      }
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/dashboard" />;
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography
                variant="h6"
                style={{
                  color: this.state.theme === "light" ? "#000" : "#fff",
                }}
              >
                {this.props.title}
              </Typography>
            </Grid>
          </Grid>
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={true}
              color={"green"}
              autoHideDuration={6000}
              message={this.state.message}
            ></Snackbar>
          ) : null}
          <div
            // style={{
            //   background: "#5b5757",
            //   padding: "20px",
            //   borderRadius: "10px",
            //   // color: rgba(0, 0, 0, 0.87);
            //   width: "100%",
            //   border: "0",
            //   display: "flex",
            //   position: "relative",
            //   fontSize: ".875rem",
            //   minWidth: "0",
            //   wordWrap: " break-word",
            //   /* background: #FFF; */
            //   boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
            //   marginTop: "30px",
            //   borderRadius: "6px",
            //   marginBottom: "30px",
            //   flexDirection: "column",
            //   textAlign: "left",
            // }}
            style={{
              padding: "20px",
              border: "1px solid #afa2a2",
              borderRadius: "7px",
              position: "relative",
              marginTop: "37px",
              // background:"#3f51b530"
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>
            <span
              style={{
                color: "#afa3a3",
                marginTop: "-8px",
                marginLeft: "26px",
                marginBottom: "35px",
                fontSize: "17px",
                display: "flex",
              }}
            >
              {/* About Us */}.
            </span>

            <CKEditor
              editor={ClassicEditor}
              data={this.state.description}
              onChange={(event, editor) => {
                const data = editor.getData();
                // console.log({ event, editor, data });
                this.setState({
                  description: data,
                });
              }}
            />
            {this.state.descError ? (
              <div style={{ color: "red" }}>required*</div>
            ) : (
              ""
            )}

            <Button
              variant="contained"
              type="submit"
              Size={15}
              style={{ width: "15%", marginTop: "20px" }}
              color="primary"
              onClick={this.updateAbout}
            >
              {this.state.loading ? "Updating.." : "Update"}
            </Button>
            {/* <Link
                  to={{
                    pathname: "/blogs",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    Size={15}
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link> */}
          </div>{" "}
        </Container>
      );
    }
  }
}
